import styled, { css, CSSProperties } from 'styled-components';
import { taggedWhite, white } from 'styles/Colors';

export const VersusOverlay = styled.div`
  position: absolute;
  color: rgba(255, 255, 255, 0.08);
  font-weight: 500;
  width: 100%;
  font-size: 150px;
  text-align: center;
  height: 100%;
  font-family: Oswald;
  line-height: 190px;
  overflow: hidden;
  user-select: none;
`;

export const TileGradientOverlay = styled.div`
  padding-top: 50px;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  user-select: none;
  position: absolute;
`;

export const TeamName = styled.div<{ isTagged?: boolean }>`
  font-family: Oswald;
  font-size: 32px;
  font-weight: 500;
  line-height: 44.8px;
  letter-spacing: 1px;
  text-align: center;
  color: ${(props) => (props.isTagged ? 'rgba(255, 255, 255, 0.5)' : white)};
  text-transform: uppercase;
`;

export const ScheduledGameTileWrapper = styled.div<{ isNextGame?: boolean }>`
  overflow: hidden;
  display: inline-block;
  width: 49%;
  height: 250px;
  background-size: cover;
  background-position: bottom;
  border-radius: 5px;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
  &:hover {
    box-shadow: 0 4px 17px 2px rgba(0, 0, 0, 0.16);
  }
  &:nth-of-type(2n + 1) {
    margin-right: 2%;
  }

  ${(props) =>
    props.isNextGame &&
    css`
      width: 100%;
      height: 450px;
      ${VersusOverlay} {
        font-size: 700px;
        line-height: 400px;
      }
      ${TeamName} {
        font-size: 40px;
        line-height: 56px;
      }
      ${TileGradientOverlay} {
        padding-top: 150px;
      }
    `}
`;

export const Badge = styled.div<{ backgroundColor: CSSProperties['backgroundColor']; opacity?: CSSProperties['opacity'] }>`
  border-radius: 32px;
  padding: 5px 8px;
  color: ${white};
  background-color: ${(props) => props.backgroundColor};
  opacity: ${(props) => props.opacity};
`;

export const BadgeWrapper = styled.div`
  position: absolute;
  bottom: 80px;
  left: 15px;
  display: flex;
  gap: 8px;
  font-family: Lato;
  font-size: 11px;
  font-weight: 600;
  line-height: 10px;
`;

export const GameDetails = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 10px 20px 10px 20px;
  background-color: rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GameId = styled.div`
  font-family: Lato;
  font-size: 15px;
  line-height: 21px;
  color: ${white};
  opacity: 0.5;
`;

export const ScheduledFor = styled.div<{ isTagged?: boolean }>`
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  color: ${(props) => (props.isTagged ? 'rgba(255, 255, 255, 0.5)' : white)};
`;

export const BackgroundOverlay = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
`;

export const TaggedWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: ${taggedWhite};
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
`;
